export default __webpack_public_path__ + "static/media/logo_caption_dove_outline.40cd2835.svg";